import { AppNS } from 'app';
import { API_URL } from 'app/core/config';
import { PaymentMethodItem } from 'app/types';

import { request } from '../config';

const JOB_SWO_CHECK_URL = 'jobs/swo-check';

export function getSwoCheckForJobById(id: string): Promise<PaymentMethodItem[]> {
  return request(
    {
      baseURL: API_URL,
      url: `${JOB_SWO_CHECK_URL}.json`,
      method: 'GET',
      params: { id },
    },
    (data) => data
  );
}

export function apiGetJobsForListing(
  params: AppNS.Params,
  signal?: AbortSignal
): Promise<AppNS.GetProjectLeadsApiResponse> {
  return request(
    {
      url: 'jobs.json',
      method: 'GET',
      params: {
        ...params,
        limit: params.limit || 20,
      },
      signal,
    },
    (data) => {
      const d = data;
      return {
        ...d.models,
      };
    }
  );
}
